import { message } from "antd";

import { MutableRefObject } from "react";

import { API_CENTER } from "../../../../services/api/api";
import { checkCSPFlash } from "../../../../utils/utilities/crypto-pro/checkCSPFlash";
import { Response } from "../../../../store/api/apiCore";
import { getSignedFile } from "../../../../utils/utilities/crypto-pro/getSignedFile";
import { DocumentWithMetaData } from "../../../../types/documents.type";

export interface ApplicationDocumentsToSign {
  application_bank_id: number;
  application_id: number;
  bankTitle: string;
  documents: DocumentWithMetaData[];
}

/**
 * Подписание документов
 * @param applicationBankId id заявки, документы которой нужно подписать
 * @param thumbprint отпечаток ЭЦП
 * @param abortRef ref для отмены подписания (если true, процесс прерывается)
 */

export const signDocumentsByAppId = async (
  applicationBankId: number,
  thumbprint: string,
  abortRef: MutableRefObject<boolean>
) => {
  const apiStart = new API_CENTER();
  let signingSuccess = true;

  // Проверка вставлена ли флешка
  await checkCSPFlash(thumbprint);

  // Получаем документы на подписание по id заявки
  const docsData: Response<ApplicationDocumentsToSign> =
    await apiStart.configAxios(
      `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/sign`,
      {
        method: "POST",
        data: { appBankId: applicationBankId },
      },
      true,
      false
    );

  message.info(`Подпись документов заявки №${applicationBankId}`);
  for await (const doc of docsData.data.documents) {
    if (abortRef.current) {
      message.error("Подписание остановлено");
      signingSuccess = false;
      break;
    }

    try {
      // Если документ прикреплен и не подписан, выполняем подписание
      if (doc.document) {
        message.success(`Подпись документа "${doc.name}"`);
        // Получаем файл документа
        const docFile: Blob = await apiStart.configAxios(
          `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/file/${doc.document.id}`,
          {
            method: "GET",
            responseType: "blob",
          },
          true,
          false
        );

        // Подписание файла через КриптоПро
        const signedDocFile = await getSignedFile({
          fileName: doc.document.name,
          file: docFile,
          thumbprint: thumbprint,
        });

        // Данные для сервера
        const formData = new FormData();
        if (signedDocFile) {
          formData.append("file", signedDocFile);
        }

        // Отправка подписанного файла на сервер
        await apiStart.configAxios(
          `auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/sign/file/${doc.document.id}`,
          {
            method: "POST",
            data: formData,
          },
          true,
          false
        );
      }
    } catch (err) {
      if (err instanceof Error) {
        message.error(err.message);
      }

      signingSuccess = false;
      break;
    }
  }

  if (signingSuccess) {
    try {
      await apiStart.configAxios(
        `/auth/system-bank/bank/kamkombank/application-bank/${applicationBankId}/signing-all-documents`,
        {
          method: "POST",
        },
        true,
        false
      );
    } catch (err) {
      if (err instanceof Error) {
        message.error(err.message);
      }
    }
  }
};
